import type { ChangeEvent } from "react";
import { useState } from "react";
import { DefaultValueMatcher } from "../../../models/matchers/DefaultValueMatcher";
import { DlfMatcherLabel } from "../../inputGroup/DlfMatcherLabel";
import { InputGroup } from "../../inputGroup/InputGroup";
import { FieldMatcherEditorChildProps } from "../FieldMatcherEditor";

type Props = {
  matcher: DefaultValueMatcher;
  update: (dlf: DefaultValueMatcher) => void;
} & FieldMatcherEditorChildProps<DefaultValueMatcher>;

const DefaultValueDlfEditor = (props: Props) => {
  const [inputValue, setInputValue] = useState(props.matcher.defaultValue);

  return (
    <div className={"fieldMatcherEditor defaultDlfEditor"}>
      <InputGroup button={props.button != undefined}>
        <DlfMatcherLabel label={"Hardcode"} {...props} />
        <input
          type={"text"}
          className={"monospace"}
          value={inputValue}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setInputValue(e.target.value)
          }
          onBlur={() => {
            if (inputValue !== props.matcher.defaultValue) {
              props.matcher.defaultValue = inputValue;
              props.update(props.matcher);
            }
          }}
        />
        {props.button && props.button}
      </InputGroup>
    </div>
  );
};

export { DefaultValueDlfEditor, Props as DefaultValueDlfEditorProps };
